import ShokzMember, { MEMBER_REGISTER_SUCCESS_MESSAGE } from "@theme/shokz-member";
import { createApp, ref } from "vue";

/** @type {SimpleToast} */
const simpleToast = document.getElementById('simple-toast');

const pageStatusMessage = document.querySelector('[data-page-status-message]');
const pageStatusRetry = document.querySelector('[data-page-status-retry]');

pageStatusRetry.addEventListener('click', (e) => {
  onRetry(e);
});

function onRetry(e) {
  console.log('[page-hub]: onRetry');
  fetchInitData();
}

function pushSelectContent(contentType, contentName, buttonName) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event_parameters: null });
  window.dataLayer.push({
    event: 'ga4Event',
    event_name: 'select_content',
    event_parameters: {
      content_type: contentType,
      content_name: contentName,
      button_name: buttonName,
    },
  });
}

const REFERRAL_SIGNUP_GA4 = {
  contentType: 'signup_referral_page',
  contentName: 'Referral_Landing',
  buttonName: 'Join For Free',
};

/**
 * 设置失败状态
 */
function setFailed(message) {
  document.body.setAttribute('data-page-status', 'failed');
  pageStatusMessage.textContent = message || 'Failed to load information, please try again later.';
}
/**
 * 设置成功状态
 */
function setSuccess() {
  document.body.setAttribute('data-page-status', 'completed');
  maybeScrollToHubSectionOnEntry();
}
/**
 * 设置加载状态
 */
function setLoading() {
  document.body.setAttribute('data-page-status', 'loading');
}

function setNotJoined() {
  document.body.classList.remove('hub-member--joined');
}

function setJoined() {
  document.body.classList.add('hub-member--joined');
}

let hubEntryScrollDone = false;

/** @type {Record<string, () => Element | null>} */
const HUB_ENTRY_SCROLL_TARGETS = {
  'Your-benefits': () => document.querySelector('hub-benefits'),
  'member-referral': () => document.getElementById('hub-referral-part'),
};

function getHubEntryScrollHash() {
  const hash = decodeURIComponent(window.location.hash.slice(1));
  return hash in HUB_ENTRY_SCROLL_TARGETS ? hash : null;
}

function getHubScrollOffset() {
  const header =
    document.querySelector('.header-wrapper') ||
    document.querySelector('sticky-header') ||
    document.querySelector('header.header');
  if (!header) return 100;
  return Math.ceil(header.getBoundingClientRect().height);
}

function scrollToHubEntrySection(getTarget) {
  const section = getTarget();
  if (!section) return;

  const target = section.closest('.shopify-section') || section;
  const targetTop =
    target.getBoundingClientRect().top + window.pageYOffset - getHubScrollOffset();
  window.scrollTo({ top: Math.max(0, targetTop), behavior: 'smooth' });
}

function maybeScrollToHubSectionOnEntry() {
  const scrollHash = getHubEntryScrollHash();
  if (hubEntryScrollDone || !scrollHash) return;
  if (!window.customer?.email) return;
  if (!document.body.classList.contains('hub-member--joined')) return;
  if (document.body.getAttribute('data-page-status') !== 'completed') return;
  if (!HUB_ENTRY_SCROLL_TARGETS[scrollHash]()) return;

  hubEntryScrollDone = true;
  const getTarget = HUB_ENTRY_SCROLL_TARGETS[scrollHash];
  requestAnimationFrame(() => {
    requestAnimationFrame(() => scrollToHubEntrySection(getTarget));
  });
}

/**
 * 获取初始化数据并设置状态
 */
function fetchInitData() {
  setLoading();
  // 获取会员信息
  ShokzMember.getMemberData().then(data => {
    const memberData = data?.data;
    ShokzMember.setMemberData(memberData);

    console.log('[page-hub]: memberData', memberData);
    if (data?.code == 404) {
      // 未加入会员
      setNotJoined();
      setSuccess();
      return;
    }
    if (data?.code == 0 && memberData != undefined) {
      /** 设置会员等级 */
      const tierNum = ShokzMember.getTierNumber();
      console.log('[page-hub]: tierNum', tierNum);
      if (tierNum < 0) {
        setFailed("Tier not found, please try again later.");
        setNotJoined();
        // setSuccess();
      } else {
        document.body.classList.add(`member-tier-${tierNum}`);
        document.body.style.setProperty('--current-member-tier', tierNum);
        // 通知其他模块会员信息已初始化
        publish(PUB_SUB_EVENTS.memberInfoInitialized, memberData);
        setJoined();
        setSuccess();
      }
    } else {
      setFailed(data?.message);
    }
  }).catch(error => {
    console.error('[page-hub]: getMemberDataByOnceCall error', error);
    setFailed(error?.message);
  });
}

if (ShokzMember.isMember()) {
  setJoined();
  fetchInitData();
} else {
  setNotJoined();
  setSuccess();
}

class HubNotJoined extends HTMLElement {
  constructor() {
    super();
    this.grid = this.querySelector('[data-grid]');
    this.gridV2 = this.querySelector('[data-grid-v2]');
    this.viewMoreButton = this.querySelector('[data-view-more-button]');
    this.viewLessButton = this.querySelector('[data-view-less-button]');
    this.termsElements = {
      /** @type {HTMLInputElement} */
      form: this.querySelector('[data-terms-form]'),
      checkbox: this.querySelector('[data-terms-checkbox]'),
      submitButton: this.querySelector('[data-terms-submit]'),
      referralEmailInput: this.querySelector('[name="referrel_register_email"]'),
    };
    this._onClickTermsButton = this.onClickTermsButton.bind(this);
    this._onClickViewMoreButton = this.onClickViewMoreButton.bind(this);
    this._onClickViewLessButton = this.onClickViewLessButton.bind(this);
  }

  connectedCallback() {
    this.attachEvent();
  }

  disconnectedCallback() {
    this.detachEvent();
  }

  attachEvent() {
    this.termsElements.submitButton?.addEventListener('click', this._onClickTermsButton);
    this.viewMoreButton?.addEventListener('click', this._onClickViewMoreButton);
    this.viewLessButton?.addEventListener('click', this._onClickViewLessButton);
  }

  detachEvent() {
    this.termsElements.submitButton?.removeEventListener('click', this._onClickTermsButton);
    this.viewMoreButton?.removeEventListener('click', this._onClickViewMoreButton);
    this.viewLessButton?.removeEventListener('click', this._onClickViewLessButton);
  }

  isReferralUserLoggedIn() {
    return Boolean(window.customer?.email);
  }

  getReferralSignInUrl() {
    return (
      this.termsElements.form?.dataset?.signInUrl ||
      '/customer_authentication/login?return_to=/pages/shokzsquad-benefits'
    );
  }

  getReferralRedirectTarget() {
    if (this.isReferralUserLoggedIn()) {
      return {
        url: '/pages/shokzsquad-benefits',
        alreadyMemberToast: 'Already a member. Redirecting to Member Hub...',
      };
    }

    return {
      url: this.getReferralSignInUrl(),
      alreadyMemberToast: 'Already a member. Redirecting to login...',
    };
  }

  redirectToReferralDestination({ toastMessage, delayMs = 2000 } = {}) {
    const { url, alreadyMemberToast } = this.getReferralRedirectTarget();
    simpleToast.show(toastMessage || alreadyMemberToast);
    window.setTimeout(() => {
      window.location.href = url;
    }, delayMs);
  }

  onClickTermsButton(e) {
    const validity = this.termsElements.form.reportValidity();
    if (!validity) return;
    if (!this.termsElements.checkbox.checked) {
      console.warn('TermsButton not checked');
      return;
    }
    if (this.termsElements.submitButton.disabled) {
      return;
    }
    if (this.termsElements.submitButton.classList.contains('loading')) {
      return;
    }

    const isReferralForm = this.termsElements.form?.hasAttribute('data-referral-form');
    const params = new URLSearchParams(window.location.search);
    const referralId = params.get('referral_id') || '';
    const referralEmail = this.termsElements.referralEmailInput?.value?.trim() || '';

    if (isReferralForm) {
      if (this.termsElements.form?.dataset?.referralVerified === 'pending') {
        return;
      }
      if (!referralEmail) {
        simpleToast.show('Please enter your email.');
        this.termsElements.referralEmailInput?.focus();
        return;
      }

      pushSelectContent(
        REFERRAL_SIGNUP_GA4.contentType,
        REFERRAL_SIGNUP_GA4.contentName,
        REFERRAL_SIGNUP_GA4.buttonName
      );
    }

    this.termsElements.submitButton.classList.add('loading');

    if (isReferralForm) {
      const useReferralRegister =
        this.termsElements.form?.dataset?.referralVerified === 'true' && referralId;
      this.submitReferralRegistration(referralId, referralEmail, useReferralRegister);
      return;
    }

    ShokzMember.joinMember()
      .then((res) => this.handleJoinResponse(res, false))
      .catch((err) => {
        console.error(err);
        ShokzMember.pushMembershipSignup({
          contentType: 'page',
          contentName: 'Membership_Page',
          payload: { code: -1, member_status: 'fail' },
        });
        simpleToast.show(err?.message || 'An unknown error occurred, please try again later.');
      })
      .finally(() => {
        this.termsElements.submitButton.classList.remove('loading');
      });
  }

  handleJoinResponse(res, isReferralForm) {
    ShokzMember.pushMembershipSignup({
      contentType: 'page',
      contentName: isReferralForm ? 'Referral_Page' : 'Membership_Page',
      payload: res,
    });

    if (res?.code == 0) {
      console.log(res);
      if (!isReferralForm) {
        pushSelectContent('guide', 'guide_member_join', 'Join_For_Free');
      }
      simpleToast.show(MEMBER_REGISTER_SUCCESS_MESSAGE);
      if (isReferralForm) {
        const { url } = this.getReferralRedirectTarget();
        window.location.href = url;
      } else {
        fetchInitData();
      }
      return;
    }

    simpleToast.show(res?.message || 'An unknown error occurred, please try again later.');
  }

  async submitReferralRegistration(referralId, referralEmail, useReferralRegister) {
    try {
      const memberInfo = await ShokzMember.getMemberInfoByEmail(referralEmail);
      if (ShokzMember.hasMemberInfoPayload(memberInfo)) {
        this.redirectToReferralDestination();
        return;
      }

      const res = useReferralRegister
        ? await ShokzMember.registerMember(referralId, referralEmail)
        : await ShokzMember.registerShopifyMember(referralEmail);
      this.handleJoinResponse(res, true);
    } catch (err) {
      console.error(err);
      ShokzMember.pushMembershipSignup({
        contentType: 'page',
        contentName: 'Referral_Page',
        payload: { code: -1, member_status: 'fail' },
      });
      simpleToast.show(err?.message || 'An unknown error occurred, please try again later.');
    } finally {
      this.termsElements.submitButton.classList.remove('loading');
    }
  }

  onClickViewMoreButton(e) {
    pushSelectContent('guide', 'guide_member_join', 'View_More');
    this.gridV2?.classList.add('grid--view-more');
    this.viewMoreButton?.classList.add('hidden');
    this.viewLessButton?.classList.remove('hidden');
  }

  onClickViewLessButton(e) {
    pushSelectContent('guide', 'guide_member_join', 'View_More');
    this.gridV2?.classList.remove('grid--view-more');
    this.viewMoreButton?.classList.remove('hidden');
    this.viewLessButton?.classList.add('hidden');
  }
}

if (!customElements.get('hub-not-joined')) {
  customElements.define('hub-not-joined', HubNotJoined);
}

class HubGallery extends HTMLElement {
  constructor() {
    super();

    this.autoplay = this.getAttribute('data-swiper-autoplay') == 'true';
    this.reverseDirection = this.getAttribute('data-swiper-reverseDirection') == 'true';
    this.speed = Number(this.getAttribute('data-swiper-speed'));
    if (isNaN(this.speed)) {
      this.speed = 40000;
    } else {
      this.speed = this.speed * 1000;
    }
    this.createSlider();
  }

  createSlider() {
    this.mySwiper = new Swiper(this.querySelector('[data-swiper-element]'), {
      slidesPerView: 'auto',
      loop: true,
      freeMode: false,
      // noSwiping: true,
      grabCursor: true,
      updateOnWindowResize: true,
      autoplay: this.autoplay
        ? {
          delay: 0,
          disableOnInteraction: false,
        }
        : false,
      speed: this.speed,
    });
  }
}

if (!customElements.get('hub-gallery')) {
  customElements.define('hub-gallery', HubGallery);
}